import { useLanguage } from '../../../../../context/LanguageContext';

type TFunction = ReturnType<typeof useLanguage>['t'];

// The "selectedCount" translation uses a literal "{count}" placeholder rather than the
// "{{count}}" syntax that `t`'s own params substitution handles, so it needs a manual replace.
export const formatSelectedCount = (t: TFunction, count: number): string =>
    t('pages.clients.queryBuilder.simple.selectedCount').replace('{count}', String(count));
